import Code from './icons/code.icon.svg';
import Cookie from './icons/cookie.icon.svg';
import Device from './icons/device.icon.svg';
import Flag from './icons/flag.icon.svg';
import Hash from './icons/hash.icon.svg';
import { type Decoded, type FlagIssue, flags, preview, validateFlags } from './utils';

export function config(decoded: Decoded) {
    const flagsData = flags(decoded);
    const validation = validateFlags(flagsData);
    const noIssues = new Map<string, FlagIssue>();

    return {
        device: {
            id: 'device',
            icon: <Device />,
            title: 'Headers',
            text: 'Values that describe the client device and environment.',
            label: 'Header',
            subtitle: preview(decoded.headers),
            data: decoded.headers,
            count: decoded.headers.size,
            status: 'success',
            issues: noIssues,
        },
        flags: {
            id: 'flags',
            icon: <Flag />,
            title: 'Feature Flags',
            text: 'Active feature flag decisions for this request.',
            label: 'Flag',
            subtitle: preview(flagsData),
            data: flagsData,
            count: validation.errors ? validation.errors : validation.warnings ? validation.warnings : flagsData.size,
            status: validation.severity,
            issues: validation.issues,
        },
        cookies: {
            id: 'cookies',
            icon: <Cookie />,
            title: 'Cookies',
            text: 'Cookies that influence the cached response.',
            label: 'Cookie',
            subtitle: preview(decoded.cookies),
            data: decoded.cookies,
            count: decoded.cookies.size,
            status: 'success',
            issues: noIssues,
        },
        query: {
            id: 'query',
            icon: <Code />,
            title: 'Query Params',
            text: 'Query parameters included in the cache key.',
            label: 'Param',
            subtitle: preview(decoded.search),
            data: decoded.search,
            count: decoded.search.size,
            status: 'success',
            issues: noIssues,
        },
        raw: {
            id: 'raw',
            icon: <Hash />,
            title: 'Raw cache key',
            text: 'Base64 encoded cache key.',
            label: 'Name',
            data: new Map<string, string>(),
            subtitle: 'Base64 encoded',
            count: 0,
            status: 'success',
            issues: noIssues,
        },
    } as const;
}

export type Config = ReturnType<typeof config>;
export type Id = keyof Config;
